import React, { Component } from "react";
import { NavLink, Switch, Route } from "react-router-dom";
import logo from "../../assets/images/cervais-s-logo.svg";
import Home from "../../components/Home/Home";
import Access from "../../components/Access/Access";
import Trusted from "../../components/Trusted/Trusted";
import DataSharing from "../../components/Trusted/DataSharing/DataSharing";
import FileSharing from "../../components/Trusted/FileSharing/FileSharing";
import MqttFileSharing from "../../components/Trusted/FileSharing/MqttFileSharing";
import MqttSubFileSharing from "../../components/Trusted/FileSharing/MqttSubFileSharing";
import UpgradePlan from "../../components/Trusted/UpgradePlan/Upgrade";
import SubFileSharing from "../../components/Trusted/FileSharing/SubFileSharing";
import Maps from "../../components/Maps/Tracking";
import IOTDevicesDetails from "../../components/Maps/IotDeviceDetails/IotDeviceDetails";
import Registration from "../../components/Registration/Registration";
import ConnectedUsers from "../../components/Registration/ConnectedUsers/ConnectedUsers";
import ConnectedDevices from "../../components/ConnectedDevices/ConnectedDevices";
import SwitchDevice from "../../components/SwitchDevice/SwitchDevice";
import VulnerabilityScan from "../../components/VulnerabilityScan/VulnerabilityScan";
import More from "../../components/More/More";
import Notification from "../../components/Notification/Notification";
import Profile from "../../components/Profile/Profile";
import Settings from "../../components/Settings/Settings";
import IotDevices from "../../components/Home/IotDevices/IotDevices";
import Error404 from "../../containers/404/404";
import AboutUs from "../../components/More/AboutUs/AboutUs";
import Help from "../../components/Help/Help";
import Feedback from "../../components/Feedback/Feedback";
import Admin from "../../containers/admin/admin";
import Modal from "@material-ui/core/Modal";
import userMethods from "../../services/userApi";
import { toast } from "react-toastify";
import { Chat } from "../../components/Trusted/Chat/Chat";
import ChatClass from "../../components/Trusted/Chat/ChatClass";
import UpdateVulnerabilityScan from "../../components/VulnerabilityScan/UpdateVulnerabilityScan";
import VulnerabilityScanReportsById from "../../components/VulnerabilityScan/VulnerabilityScanReportsById";
import guardian from "../../assets/images/sgx.png";

class dashboard extends Component {
  state = {
    isAuthenticated: true,
    showModal: false,
    userType: "Admin",
    email: "",
    errorEmail: "",
    alertEmail: "",
    isEmailValid: false,
    loader: false,
    showLogout: false,
    device_details: JSON.parse(sessionStorage.getItem("UserDetails")),
    role_id: JSON.parse(sessionStorage.getItem("role_id")),
  };

  componentDidMount() {
    this.setState({
      isAuthenticated: window.sessionStorage.getItem("isAuthenticated"),
    });
    window.addEventListener("storage", this.handleStorageChange);
  }

  componentWillUnmount() {
    window.removeEventListener("storage", this.handleStorageChange);
  }
  // componentDidUpdate(prevProps, prevState) {
  //   if (
  //     this.state.role_id ==
  //     (JSON.parse(JSON.stringify(sessionStorage))?.role
  //       ? JSON.parse(JSON.stringify(sessionStorage))?.role_id
  //       : null)
  //   ) {
  //     this.handleStorageChange();
  //   }
  // }

  handleStorageChange = () => {
    if (sessionStorage.getItem("UserDetails")) {
      sessionStorage.removeItem("UserDetails");
      setTimeout(() => window.location.reload(), 5000);
    }
  };

  handleOpen = () => {
    this.setState({ showModal: true });
  };

  handleClose = () => {
    this.setState({ showModal: false, showLogout: false });
  };

  changeUsertype = (event) => {
    this.setState({
      userType: event.target.value,
    });
  };

  validateEmail(email) {
    const pattern =
      /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

    return pattern.test(email);
  }

  handleEmail = (event) => {
    this.setState({ email: event.target.value });

    // Checks if email is valid or not
    this.setState({ isEmailValid: this.validateEmail(this.state.email) });

    if (!this.state.isEmailValid) {
      this.setState({ errorEmail: "Please enter valid email-id" });
    } else {
      this.setState({ errorEmail: "" });
    }
  };

  postInviteUser = async () => {
    if (this.state.email === "") {
      this.setState({ errorEmail: "Please enter email-id" });
    }

    if (this.validateEmail(this.state.email) && this.state.email !== "") {
      this.setState({ loader: true });

      var inviteObject = {
        email_address: this.state.email,
        userType: this.state.userType,
        device_id: JSON.parse(window.sessionStorage.getItem("ConnectedDevice"))
          ?.device_id,
      };

      const response = await userMethods.inviteUser(inviteObject);
      if (response.data.statusCode === 200) {
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
      if (response) {
        this.setState({
          showModal: false,
          userType: "Admin",
          email: "",
          errorEmail: "",
          alertEmail: "",
          isEmailValid: false,
          loader: false,
        });
      }
    }
  };

  handleLogout = () => {
    this.setState({
      showLogout: true,
    });
  };

  logoutUser = () => {
    this.setState({ loader: true, showLogout: false });
    window.sessionStorage.clear();
    this.props.history.replace({
      pathname: "/",
    });
  };

  render() {
    console.log(
      JSON.parse(JSON.stringify(sessionStorage))?.ConnectedDevice
        ? JSON.parse(
            JSON.parse(JSON.stringify(sessionStorage))?.ConnectedDevice
          ).role_id
        : null
    );
    return (
      <main className="rout-main-wrap">
        <aside className="sidebar-wrap scroll">
          <div className="nav-toplogo text-center mb-3">
            <div className="guardian-logo">
              <img
                className="f-logo"
                src={guardian}
                alt="Cervais"
                title="Cervais"
              />
            </div>
            {/* <h4 className="mr-t20 mr-b10 armia-font">Welcome to ARMIA SG-X</h4> */}
            <h4 className=" mr-b10 armia-font text-white">SG-X GuArDiAn</h4>
          </div>
          <div className="nav-wrap mt-3" style={{ marginTop: 30 }}>
            <nav>
              <ul>
                <li>
                  <NavLink
                    to={"/dashboard/home"}
                    exact
                    activeClassName="active-nav "
                  >
                    <div className="nav-icon">
                      <svg
                        width="22"
                        height="20"
                        viewBox="0 0 22 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4.88867 8L10.89 1.99867L16.8913 8H16.89V18H4.89001V8H4.88867ZM2.89001 9.99866L1.4132 11.4755L0 10.0623L9.47699 0.58529C10.2574 -0.195097 11.5226 -0.195097 12.303 0.58529L21.78 10.0623L20.3668 11.4755L18.89 9.99869V18C18.89 19.1046 17.9946 20 16.89 20H4.89001C3.78545 20 2.89001 19.1046 2.89001 18V9.99866Z"
                          fill="#ffffff"
                        />
                      </svg>
                    </div>
                    Home
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={"/dashboard/access"}
                    activeClassName="active-nav"
                  >
                    <div className="nav-icon">
                      <svg
                        width="22"
                        height="25"
                        viewBox="0 0 22 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.7439 10.7349H14.3129V10.0189C14.3129 9.06986 13.9358 8.15965 13.2647 7.48856C12.5936 6.81746 11.6834 6.44043 10.7344 6.44043C9.78528 6.44043 8.87508 6.81746 8.20398 7.48856C7.53288 8.15965 7.15585 9.06986 7.15585 10.0189V10.7349H5.72485V16.5559H15.7439V10.7349ZM12.8809 10.7349H11.4499V13.5979H10.0189V10.7349H8.58786V10.0189C8.58786 9.44952 8.81405 8.90342 9.21669 8.50078C9.61933 8.09814 10.1654 7.87193 10.7348 7.87193C11.3043 7.87193 11.8504 8.09814 12.253 8.50078C12.6556 8.90342 12.8819 9.44952 12.8819 10.0189L12.8809 10.7349Z"
                          fill="white"
                        />
                        <path
                          d="M-0.000114242 17.987C-0.00112183 18.4083 0.122109 18.8205 0.354162 19.1721C0.586216 19.5236 0.916788 19.799 1.30453 19.9637C1.69227 20.1284 2.11996 20.175 2.5341 20.0979C2.94824 20.0208 3.33044 19.8232 3.63289 19.53L8.61388 22.021C8.59987 22.107 8.59119 22.1939 8.58789 22.281C8.58789 22.8504 8.81409 23.3965 9.21673 23.7992C9.61937 24.2018 10.1655 24.428 10.7349 24.428C11.3043 24.428 11.8504 24.2018 12.253 23.7992C12.6557 23.3965 12.8819 22.8504 12.8819 22.281C12.8786 22.1939 12.8699 22.107 12.8559 22.021L17.8369 19.53C18.0667 19.7534 18.3438 19.9223 18.6476 20.0244C18.9515 20.1265 19.2743 20.159 19.5924 20.1197C19.9105 20.0804 20.2157 19.9702 20.4856 19.7973C20.7554 19.6243 20.983 19.393 21.1516 19.1204C21.3201 18.8478 21.4254 18.5408 21.4595 18.2221C21.4937 17.9034 21.4559 17.5811 21.3489 17.279C21.2419 16.9769 21.0685 16.7026 20.8414 16.4764C20.6144 16.2502 20.3394 16.0778 20.0369 15.972V8.456C20.3394 8.35018 20.6144 8.17782 20.8414 7.95162C21.0685 7.72541 21.2419 7.45113 21.3489 7.14899C21.4559 6.84685 21.4937 6.52456 21.4595 6.20587C21.4254 5.88718 21.3201 5.58021 21.1516 5.3076C20.983 5.03499 20.7554 4.80368 20.4856 4.63072C20.2157 4.45777 19.9105 4.34757 19.5924 4.30827C19.2743 4.26896 18.9515 4.30154 18.6476 4.40361C18.3438 4.50567 18.0667 4.67462 17.8369 4.898L12.8559 2.407C12.8699 2.32095 12.8786 2.23412 12.8819 2.147C12.8819 1.57758 12.6557 1.03148 12.253 0.628842C11.8504 0.226201 11.3043 0 10.7349 0C10.1655 0 9.61937 0.226201 9.21673 0.628842C8.81409 1.03148 8.58789 1.57758 8.58789 2.147C8.59119 2.23412 8.59987 2.32095 8.61388 2.407L3.63289 4.9C3.40303 4.67662 3.12598 4.50767 2.82215 4.40561C2.51832 4.30354 2.19545 4.27096 1.87736 4.31027C1.55926 4.34958 1.25404 4.45977 0.984192 4.63272C0.714345 4.80568 0.486753 5.03699 0.31819 5.3096C0.149627 5.58221 0.0443918 5.88918 0.0102408 6.20787C-0.0239103 6.52656 0.0138945 6.84885 0.120867 7.15099C0.227839 7.45313 0.401252 7.72741 0.628325 7.95362C0.855397 8.17982 1.13034 8.35218 1.43288 8.458V15.974C1.01553 16.1207 0.653782 16.3929 0.397228 16.7533C0.140675 17.1137 0.00188368 17.5446 -0.000114242 17.987ZM2.86288 8.456C3.28018 8.30885 3.64173 8.0362 3.89793 7.67544C4.15414 7.31467 4.29244 6.88348 4.29388 6.441C4.29058 6.35388 4.2819 6.26705 4.26789 6.181L9.24889 3.69C9.64671 4.07704 10.1798 4.2936 10.7349 4.2936C11.2899 4.2936 11.8231 4.07704 12.2209 3.69L17.1999 6.181C17.1859 6.26705 17.1772 6.35388 17.1739 6.441C17.1753 6.88348 17.3136 7.31467 17.5698 7.67544C17.826 8.0362 18.1876 8.30885 18.6049 8.456V15.972C18.1876 16.1191 17.826 16.3918 17.5698 16.7526C17.3136 17.1133 17.1753 17.5445 17.1739 17.987C17.1772 18.0741 17.1859 18.161 17.1999 18.247L12.2189 20.738C11.8211 20.351 11.2879 20.1344 10.7329 20.1344C10.1778 20.1344 9.64471 20.351 9.24689 20.738L4.26588 18.247C4.2799 18.161 4.28858 18.0741 4.29189 17.987C4.29045 17.5445 4.15214 17.1133 3.89594 16.7526C3.63973 16.3918 3.27818 16.1191 2.86089 15.972L2.86288 8.456Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    Access
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={"/dashboard/trusted"}
                    activeClassName="active-nav"
                  >
                    <div className="nav-icon">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M3.89126 2.56665L5.36557 3.91811C3.89657 5.51979 3 7.65503 3 9.99966C3 12.3443 3.89657 14.4795 5.36557 16.0812L3.89126 17.4327C2.09581 15.4751 1 12.8653 1 9.99966C1 7.134 2.09581 4.52427 3.89126 2.56665ZM20.1087 2.56698C21.9042 4.5246 23 7.13433 23 9.99999C23 12.8657 21.9042 15.4754 20.1087 17.433L18.6344 16.0816C20.1034 14.4799 21 12.3446 21 9.99999C21 7.65536 20.1034 5.52012 18.6344 3.91844L20.1087 2.56698ZM8.72076 22L9.38743 20H14.6126L15.2792 22H17.3874L14.1012 12.1413C14.6559 11.5969 15 10.8386 15 9.99999C15 8.34314 13.6569 6.99999 12 6.99999C10.3431 6.99999 9 8.34314 9 9.99999C9 10.8386 9.3441 11.5969 9.89882 12.1413L6.61257 22H8.72076ZM10.0541 18L10.7208 16H13.2792L13.9459 18H10.0541ZM12.6126 14L12.2751 12.9875C12.1845 12.9958 12.0927 13 12 13C11.9073 13 11.8155 12.9958 11.7249 12.9875L11.3874 14H12.6126ZM13 9.99999C13 10.5523 12.5523 11 12 11C11.4477 11 11 10.5523 11 9.99999C11 9.44771 11.4477 8.99999 12 8.99999C12.5523 8.99999 13 9.44771 13 9.99999ZM19 9.99999C19 8.17639 18.3027 6.51565 17.1601 5.26989L15.6858 6.62135C16.5019 7.51118 17 8.69742 17 9.99999C17 11.3026 16.5019 12.4888 15.6858 13.3786L17.1601 14.7301C18.3027 13.4843 19 11.8236 19 9.99999ZM8.31421 6.62102L6.83989 5.26956C5.69733 6.51532 5 8.17606 5 9.99966C5 11.8233 5.69733 13.484 6.83989 14.7298L8.31421 13.3783C7.4981 12.4885 7 11.3022 7 9.99966C7 8.69709 7.4981 7.51085 8.31421 6.62102Z"
                          fill="#E5E5E5"
                        />
                      </svg>
                    </div>
                    Trusted
                  </NavLink>
                </li>
                <li>
                  <NavLink to={"/dashboard/map"} activeClassName="active-nav">
                    <div className="nav-icon">
                      <svg
                        width="20"
                        height="21"
                        viewBox="0 0 20 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2 5.14301V17.967L7.065 15.797L13.065 18.797L18 16.68V3.85701L19.303 3.29901C19.3791 3.2664 19.4621 3.25318 19.5445 3.26056C19.627 3.26793 19.7063 3.29566 19.7754 3.34126C19.8445 3.38686 19.9012 3.4489 19.9404 3.52181C19.9796 3.59473 20.0001 3.67623 20 3.75901V18L13 21L7 18L0.697 20.701C0.620914 20.7336 0.537919 20.7468 0.455466 20.7395C0.373012 20.7321 0.293679 20.7044 0.224587 20.6588C0.155495 20.6132 0.0988058 20.5511 0.059607 20.4782C0.0204082 20.4053 -7.34563e-05 20.3238 1.9795e-07 20.241V6.00001L2 5.14301ZM14.243 10.243L10 14.485L5.757 10.243C4.91799 9.40386 4.34664 8.33476 4.11521 7.1709C3.88379 6.00704 4.00266 4.80069 4.45682 3.7044C4.91098 2.6081 5.68001 1.67109 6.66668 1.01184C7.65336 0.352601 8.81336 0.000732422 10 0.000732422C11.1866 0.000732422 12.3466 0.352601 13.3333 1.01184C14.32 1.67109 15.089 2.6081 15.5432 3.7044C15.9973 4.80069 16.1162 6.00704 15.8848 7.1709C15.6534 8.33476 15.082 9.40386 14.243 10.243ZM10 11.657L12.828 8.82801C13.3875 8.26865 13.7686 7.55592 13.9231 6.77997C14.0775 6.00401 13.9983 5.19968 13.6956 4.4687C13.3929 3.73773 12.8802 3.11294 12.2224 2.67337C11.5646 2.23379 10.7912 1.99916 10 1.99916C9.20882 1.99916 8.43542 2.23379 7.77759 2.67337C7.11977 3.11294 6.60708 3.73773 6.30437 4.4687C6.00165 5.19968 5.92251 6.00401 6.07695 6.77997C6.23139 7.55592 6.61247 8.26865 7.172 8.82801L10 11.657Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    Tracking
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={"/dashboard/settings"}
                    activeClassName="active-nav"
                  >
                    <div className="nav-icon">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.95405 2.21C11.303 1.92713 12.6958 1.92645 14.045 2.208C14.1349 2.80129 14.3574 3.36669 14.6958 3.86218C15.0343 4.35767 15.4801 4.7705 16 5.07C16.5196 5.37053 17.1002 5.55006 17.6987 5.59525C18.2973 5.64044 18.8983 5.55012 19.457 5.331C20.3753 6.35906 21.0709 7.56604 21.5 8.876C21.0314 9.25058 20.6532 9.72595 20.3935 10.2668C20.1338 10.8076 19.9993 11.4 20 12C20 13.264 20.586 14.391 21.502 15.124C21.0704 16.4329 20.3739 17.6389 19.456 18.667C18.8974 18.448 18.2966 18.3578 17.6983 18.403C17.0999 18.4482 16.5195 18.6276 16 18.928C15.4805 19.2274 15.0351 19.64 14.6968 20.1351C14.3585 20.6302 14.1361 21.1952 14.046 21.788C12.6973 22.0715 11.3044 22.0729 9.95505 21.792C9.86559 21.1982 9.64335 20.6322 9.30487 20.1361C8.96639 19.6401 8.52038 19.2268 8.00005 18.927C7.48041 18.6266 6.89975 18.4473 6.30124 18.4023C5.70272 18.3572 5.10176 18.4477 4.54305 18.667C3.62465 17.6386 2.92905 16.4313 2.50005 15.121C2.96844 14.7466 3.34651 14.2716 3.60618 13.7311C3.86586 13.1906 4.00048 12.5986 4.00005 11.999C4.00054 11.3989 3.86575 10.8064 3.60571 10.2655C3.34568 9.72466 2.96707 9.24938 2.49805 8.875C2.92972 7.56612 3.62616 6.3601 4.54405 5.332C5.1027 5.55096 5.70352 5.6412 6.30184 5.59601C6.90017 5.55082 7.48062 5.37138 8.00005 5.071C8.51959 4.7716 8.96503 4.35902 9.30331 3.86391C9.64158 3.36879 9.864 2.80384 9.95405 2.211V2.21ZM12 15C12.7957 15 13.5588 14.6839 14.1214 14.1213C14.684 13.5587 15 12.7956 15 12C15 11.2043 14.684 10.4413 14.1214 9.87868C13.5588 9.31607 12.7957 9 12 9C11.2044 9 10.4413 9.31607 9.87873 9.87868C9.31612 10.4413 9.00005 11.2043 9.00005 12C9.00005 12.7956 9.31612 13.5587 9.87873 14.1213C10.4413 14.6839 11.2044 15 12 15Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    Settings
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={"/dashboard/profile"}
                    activeClassName="active-nav"
                  >
                    <div className="nav-icon">
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.0109 12.8061C11.0616 12.8061 10.1336 12.5245 9.3442 11.9971C8.55485 11.4697 7.93962 10.72 7.57632 9.84294C7.21302 8.96585 7.11796 8.00073 7.30317 7.06962C7.48838 6.13851 7.94554 5.28324 8.61683 4.61194C9.28812 3.94065 10.1434 3.4835 11.0745 3.29829C12.0056 3.11308 12.9707 3.20813 13.8478 3.57144C14.7249 3.93474 15.4746 4.54996 16.002 5.33932C16.5294 6.12868 16.8109 7.05671 16.8109 8.00606C16.8109 8.6364 16.6868 9.26057 16.4456 9.84294C16.2043 10.4253 15.8508 10.9544 15.4051 11.4002C14.9593 11.8459 14.4302 12.1995 13.8478 12.4407C13.2655 12.6819 12.6413 12.8061 12.0109 12.8061ZM12.0109 4.80606C11.378 4.80606 10.7594 4.99373 10.2331 5.34535C9.70688 5.69697 9.29673 6.19675 9.05453 6.78147C8.81233 7.36619 8.74895 8.00961 8.87243 8.63035C8.9959 9.25108 9.30067 9.82127 9.7482 10.2688C10.1957 10.7163 10.7659 11.0211 11.3867 11.1446C12.0074 11.268 12.6508 11.2047 13.2355 10.9625C13.8203 10.7203 14.32 10.3101 14.6716 9.78388C15.0233 9.25764 15.2109 8.63896 15.2109 8.00606C15.2109 7.15736 14.8738 6.34343 14.2737 5.74331C13.6736 5.1432 12.8596 4.80606 12.0109 4.80606Z"
                          fill="white"
                        />
                        <path
                          d="M12.0092 24.0012C10.2356 23.9999 8.48434 23.6053 6.88144 22.8461C5.27854 22.0868 3.86387 20.9817 2.73924 19.6102L2.32324 19.0982L2.73924 18.5982C3.86496 17.2289 5.28005 16.1261 6.8828 15.3689C8.48555 14.6117 10.2361 14.219 12.0087 14.219C13.7813 14.219 15.5319 14.6117 17.1347 15.3689C18.7374 16.1261 20.1525 17.2289 21.2782 18.5982L21.6942 19.0982L21.2782 19.6102C20.1537 20.9816 18.7392 22.0866 17.1365 22.8459C15.5338 23.6051 13.7827 23.9997 12.0092 24.0012ZM4.41924 19.1062C5.39223 20.1478 6.56895 20.9783 7.87634 21.5461C9.18373 22.1139 10.5939 22.4069 12.0192 22.4069C13.4446 22.4069 14.8548 22.1139 16.1621 21.5461C17.4695 20.9783 18.6463 20.1478 19.6192 19.1062C18.6463 18.0646 17.4695 17.2341 16.1621 16.6663C14.8548 16.0985 13.4446 15.8055 12.0192 15.8055C10.5939 15.8055 9.18373 16.0985 7.87634 16.6663C6.56895 17.2341 5.39223 18.0646 4.41924 19.1062Z"
                          fill="white"
                        />
                        <path
                          d="M12.0092 24C9.28328 24.0021 6.63789 23.076 4.50844 21.3743C2.379 19.6725 0.892405 17.2964 0.293362 14.6371C-0.305681 11.9778 0.0185237 9.19385 1.21261 6.7434C2.4067 4.29294 4.39951 2.32205 6.86303 1.15513C9.32654 -0.0117811 12.1139 -0.305176 14.7664 0.323243C17.4189 0.951661 19.7784 2.46444 21.4565 4.61258C23.1347 6.76071 24.0314 9.41619 23.9992 12.1419C23.9669 14.8676 23.0076 17.5012 21.2792 19.609C20.1546 20.9805 18.7399 22.0856 17.137 22.8449C15.5341 23.6041 13.7828 23.9987 12.0092 24ZM12.0092 1.60601C9.95218 1.60541 7.94119 2.21483 6.23055 3.3572C4.5199 4.49956 3.18644 6.12355 2.3988 8.02379C1.61116 9.92403 1.40472 12.0152 1.80559 14.0327C2.20645 16.0503 3.19662 17.9037 4.65087 19.3585C6.10511 20.8133 7.95812 21.8042 9.97554 22.2058C11.993 22.6075 14.0842 22.4018 15.9847 21.6149C17.8853 20.828 19.5098 19.4952 20.6528 17.785C21.7958 16.0748 22.406 14.064 22.4062 12.007C22.4062 9.24876 21.3105 6.60348 19.3601 4.6531C17.4097 2.70272 14.7644 1.60701 12.0062 1.60701L12.0092 1.60601Z"
                          fill="white"
                        />
                        <path
                          d="M3.35547 19.106C3.35547 19.106 11.4095 28.106 19.6075 20.006L20.6635 19.106C20.6635 19.106 13.8175 12.006 6.86347 16.267L3.35547 19.106Z"
                          fill="white"
                        />
                        <path
                          d="M12.0088 12.0041C14.2174 12.0041 16.0078 10.2137 16.0078 8.0051C16.0078 5.79652 14.2174 4.0061 12.0088 4.0061C9.80018 4.0061 8.00977 5.79652 8.00977 8.0051C8.00977 10.2137 9.80018 12.0041 12.0088 12.0041Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    Account
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={"/dashboard/registration"}
                    activeClassName="active-nav"
                  >
                    <div className="nav-icon">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M19.2857 19L17.8571 17H21V5H3V17H6.14286L4.71429 19H3C1.89543 19 1 18.1046 1 17V5C1 3.89543 1.89543 3 3 3H21C22.1046 3 23 3.89543 23 5V17C23 18.1046 22.1046 19 21 19H19.2857ZM12 11.2795L18.9432 21H5.05681L12 11.2795ZM15.0568 19H8.94319L12 14.7205L15.0568 19Z"
                          fill="#E5E5E5"
                        />
                      </svg>
                    </div>
                    Registration
                  </NavLink>
                </li>
                {/* <li>
                  <NavLink
                    to={"/dashboard/connectedDevices"}
                    activeClassName="active-nav"
                  >
                    <div className="nav-icon">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.109 14.0593C2.54363 14.0578 2.96715 13.9219 3.32147 13.6702C3.67578 13.4184 3.94354 13.0632 4.088 12.6533H5.666C5.6097 12.1863 5.6097 11.7143 5.666 11.2473H4.088C3.94354 10.8374 3.67578 10.4822 3.32147 10.2305C2.96715 9.97874 2.54363 9.84281 2.109 9.84131C1.83204 9.84131 1.5578 9.89586 1.30192 10.0018C1.04605 10.1078 0.813551 10.2632 0.617712 10.459C0.421873 10.6549 0.266525 10.8874 0.160538 11.1432C0.0545509 11.3991 0 11.6733 0 11.9503C0 12.2273 0.0545509 12.5015 0.160538 12.7574C0.266525 13.0133 0.421873 13.2458 0.617712 13.4416C0.813551 13.6374 1.04605 13.7928 1.30192 13.8988C1.5578 14.0048 1.83204 14.0593 2.109 14.0593Z"
                          fill="white"
                        />
                        <path
                          d="M21.7923 9.84131C21.3577 9.84281 20.9342 9.97874 20.5799 10.2305C20.2255 10.4822 19.9578 10.8374 19.8133 11.2473H18.2363C18.2926 11.7143 18.2926 12.1863 18.2363 12.6533H19.8143C19.9588 13.0632 20.2265 13.4184 20.5808 13.6702C20.9352 13.9219 21.3587 14.0578 21.7933 14.0593C22.0703 14.0593 22.3445 14.0048 22.6004 13.8988C22.8563 13.7928 23.0888 13.6374 23.2846 13.4416C23.4804 13.2458 23.6358 13.0133 23.7418 12.7574C23.8478 12.5015 23.9023 12.2273 23.9023 11.9503C23.9023 11.6733 23.8478 11.3991 23.7418 11.1432C23.6358 10.8874 23.4804 10.6549 23.2846 10.459C23.0888 10.2632 22.8563 10.1078 22.6004 10.0018C22.3445 9.89586 22.0703 9.84131 21.7933 9.84131H21.7923Z"
                          fill="white"
                        />
                        <path
                          d="M9.8418 21.7923C9.8418 22.0693 9.89635 22.3435 10.0023 22.5994C10.1083 22.8553 10.2637 23.0878 10.4595 23.2836C10.6553 23.4794 10.8878 23.6348 11.1437 23.7408C11.3996 23.8468 11.6738 23.9013 11.9508 23.9013C12.2277 23.9013 12.502 23.8468 12.7579 23.7408C13.0137 23.6348 13.2462 23.4794 13.4421 23.2836C13.6379 23.0878 13.7933 22.8553 13.8993 22.5994C14.0052 22.3435 14.0598 22.0693 14.0598 21.7923C14.0583 21.3577 13.9224 20.9342 13.6706 20.5799C13.4189 20.2255 13.0637 19.9578 12.6538 19.8133V17.8033C13.5988 16.2544 14.0804 14.4673 14.0418 12.6533H9.85179C9.81456 14.4674 10.2976 16.2541 11.2438 17.8023V19.8123C10.8345 19.9575 10.48 20.2257 10.229 20.5801C9.97805 20.9346 9.8428 21.358 9.8418 21.7923Z"
                          fill="white"
                        />
                        <path
                          d="M14.0598 2.109C14.0598 1.83204 14.0052 1.5578 13.8993 1.30192C13.7933 1.04605 13.6379 0.813551 13.4421 0.617712C13.2462 0.421873 13.0137 0.266525 12.7579 0.160538C12.502 0.0545509 12.2277 0 11.9508 0C11.6738 0 11.3996 0.0545509 11.1437 0.160538C10.8878 0.266525 10.6553 0.421873 10.4595 0.617712C10.2637 0.813551 10.1083 1.04605 10.0023 1.30192C9.89635 1.5578 9.8418 1.83204 9.8418 2.109C9.8433 2.54363 9.97923 2.96715 10.231 3.32147C10.4827 3.67578 10.8379 3.94354 11.2478 4.088V6.098C10.3016 7.64619 9.81857 9.43295 9.8558 11.247H14.0458C14.083 9.43295 13.6 7.64619 12.6538 6.098V4.088C13.0637 3.94354 13.4189 3.67578 13.6706 3.32147C13.9224 2.96715 14.0583 2.54363 14.0598 2.109Z"
                          fill="white"
                        />
                        <path
                          d="M5.88522 17.0213C5.43629 16.8069 4.926 16.758 4.44455 16.8835C3.9631 17.0089 3.54149 17.3005 3.25424 17.7067C2.96698 18.1129 2.83259 18.6075 2.87479 19.1033C2.917 19.599 3.1331 20.0639 3.4849 20.4156C3.8367 20.7674 4.30154 20.9835 4.79726 21.0258C5.29298 21.068 5.78767 20.9336 6.19388 20.6463C6.60009 20.359 6.89167 19.9374 7.01709 19.456C7.1425 18.9745 7.09367 18.4642 6.87922 18.0153L8.01722 16.8773C8.50203 17.2655 9.04109 17.5805 9.61722 17.8123C8.88217 16.1897 8.48576 14.4343 8.45222 12.6533H5.66623C5.79578 13.8395 6.26487 14.9631 7.01722 15.8893L5.88522 17.0213Z"
                          fill="white"
                        />
                        <path
                          d="M18.0172 6.87923C18.4661 7.09367 18.9764 7.1425 19.4578 7.01708C19.9393 6.89167 20.3609 6.6001 20.6482 6.19389C20.9354 5.78768 21.0698 5.29299 21.0276 4.79726C20.9854 4.30154 20.7693 3.8367 20.4175 3.48491C20.0657 3.13311 19.6009 2.917 19.1051 2.87479C18.6094 2.83259 18.1147 2.96699 17.7085 3.25424C17.3023 3.5415 17.0107 3.96311 16.8853 4.44456C16.7599 4.92601 16.8087 5.4363 17.0232 5.88522L15.8852 7.02322C15.4003 6.6351 14.8613 6.32009 14.2852 6.08823C15.021 7.71096 15.4181 9.46676 15.4522 11.2482H18.2362C18.1066 10.062 17.6375 8.93841 16.8852 8.01222L18.0172 6.87923Z"
                          fill="white"
                        />
                        <path
                          d="M14.2852 17.8133C14.8613 17.5814 15.4004 17.2664 15.8852 16.8783L17.0232 18.0163C16.8087 18.4652 16.7599 18.9755 16.8853 19.4569C17.0107 19.9384 17.3023 20.36 17.7085 20.6472C18.1147 20.9345 18.6094 21.0689 19.1051 21.0267C19.6009 20.9845 20.0657 20.7684 20.4175 20.4166C20.7693 20.0648 20.9854 19.6 21.0276 19.1042C21.0698 18.6085 20.9354 18.1138 20.6482 17.7076C20.3609 17.3014 19.9393 17.0098 19.4578 16.8844C18.9764 16.759 18.4661 16.8078 18.0172 17.0223L16.8852 15.8903C17.637 14.9642 18.1057 13.841 18.2352 12.6553H15.4512C15.4172 14.436 15.0204 16.1911 14.2852 17.8133Z"
                          fill="white"
                        />
                        <path
                          d="M9.61723 6.08725C9.0411 6.31911 8.50204 6.63412 8.01723 7.02225L6.87923 5.88425C7.09367 5.43532 7.1425 4.92503 7.01708 4.44358C6.89167 3.96213 6.6001 3.54052 6.19389 3.25327C5.78768 2.96601 5.29299 2.83161 4.79726 2.87382C4.30154 2.91603 3.8367 3.13213 3.48491 3.48393C3.13311 3.83573 2.917 4.30057 2.87479 4.79629C2.83259 5.29201 2.96699 5.7867 3.25424 6.19291C3.5415 6.59912 3.96311 6.89069 4.44456 7.01611C4.92601 7.14152 5.4363 7.09269 5.88522 6.87825L7.01723 8.01025C6.26418 8.93822 5.79537 10.0641 5.66723 11.2523H8.45322C8.48726 9.47079 8.88436 7.71498 9.62022 6.09225L9.61723 6.08725Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    Connected Devices
                  </NavLink>
                </li> */}
                <li>
                  <NavLink
                    to={"/dashboard/switchDevices"}
                    activeClassName="active-nav"
                  >
                    <div className="nav-icon">
                      <svg
                        width="25"
                        height="19"
                        viewBox="0 0 25 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.9869 7.19576C13.6898 6.7086 13.218 6.35319 12.6677 6.20206C12.1175 6.05094 11.5303 6.1155 11.0261 6.38256C10.5218 6.64962 10.1385 7.09905 9.95435 7.63912C9.77018 8.17919 9.79907 8.76919 10.0351 9.28869C10.2712 9.80819 10.6966 10.218 11.2245 10.4345C11.7524 10.6511 12.3431 10.658 12.8759 10.4538C13.4088 10.2497 13.8436 9.84984 14.0917 9.33599C14.3398 8.82214 14.3824 8.23299 14.2109 7.68877C14.1564 7.51599 14.0812 7.35044 13.9869 7.19576Z"
                          fill="white"
                        />
                        <path
                          d="M12.632 12.0818H11.487C10.523 12.0818 9.59841 12.4648 8.91672 13.1465C8.23502 13.8281 7.85205 14.7527 7.85205 15.7168V18.2278H16.2661V15.7168C16.2661 14.7527 15.8831 13.8281 15.2014 13.1465C14.5197 12.4648 13.5951 12.0818 12.631 12.0818H12.632Z"
                          fill="white"
                        />
                        <path
                          d="M7.70441 7.93932C9.4508 7.21544 10.2797 5.21289 9.55584 3.4665C8.83196 1.72011 6.82941 0.891204 5.08302 1.61508C3.33663 2.33896 2.50772 4.34151 3.2316 6.0879C3.95548 7.83429 5.95802 8.6632 7.70441 7.93932Z"
                          fill="white"
                        />
                        <path
                          d="M6.435 15.7159C6.43544 14.7164 6.73192 13.7395 7.28701 12.9083C7.84211 12.0772 8.63095 11.4291 9.554 11.0459C8.94454 10.4771 8.54704 9.71775 8.427 8.89285C7.86835 9.39535 7.1403 9.66791 6.389 9.65584C5.34 9.65708 4.31928 9.31579 3.482 8.68384C2.44913 9.1248 1.56851 9.85942 0.949495 10.7965C0.330475 11.7335 0.000313027 12.8318 0 13.9548L0 16.7448H6.435V15.7159Z"
                          fill="white"
                        />
                        <path
                          d="M20.1294 7.26125C21.4662 5.92448 21.4662 3.75716 20.1294 2.42039C18.7927 1.08363 16.6254 1.08363 15.2886 2.42039C13.9518 3.75716 13.9518 5.92448 15.2886 7.26125C16.6254 8.59801 18.7927 8.59801 20.1294 7.26125Z"
                          fill="white"
                        />
                        <path
                          d="M23.1989 10.8678C22.5797 9.89636 21.681 9.135 20.6209 8.68384C19.7838 9.31621 18.763 9.65787 17.7139 9.65685C17.3414 9.66096 16.9717 9.59163 16.6259 9.45282C16.2802 9.31401 15.9652 9.10843 15.6989 8.84784C15.5876 9.69033 15.1872 10.468 14.5659 11.0479C15.489 11.4311 16.2778 12.0792 16.8329 12.9103C17.388 13.7415 17.6845 14.7184 17.6849 15.7178V16.7468H24.1019V13.9568C24.1029 12.862 23.7895 11.7898 23.1989 10.8678Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    Switch Device
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={"/dashboard/vulnerabilityScan"}
                    activeClassName="active-nav"
                  >
                    <div className="nav-icon">
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="m5.75 17.167v-2.5h12.5v2.5c0 .552-.448 1-1 1h-10.5c-.552 0-1-.448-1-1z"
                          fill="white"
                        />
                        <path
                          d="m5.75 11v-4.25c0-.552.448-1 1-1h10.5c.552 0 1 .448 1 1v4.25z"
                          fill="white"
                        />
                        <path
                          d="m23.25 7c-.414 0-.75-.336-.75-.75v-3.5c0-.689-.561-1.25-1.25-1.25h-3.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h3.5c1.517 0 2.75 1.233 2.75 2.75v3.5c0 .414-.336.75-.75.75z"
                          fill="white"
                        />
                        <path
                          d="m21.25 24h-3.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h3.5c.689 0 1.25-.561 1.25-1.25v-3.5c0-.414.336-.75.75-.75s.75.336.75.75v3.5c0 1.517-1.233 2.75-2.75 2.75z"
                          fill="white"
                        />
                        <path
                          d="m6.25 24h-3.5c-1.517 0-2.75-1.233-2.75-2.75v-3.5c0-.414.336-.75.75-.75s.75.336.75.75v3.5c0 .689.561 1.25 1.25 1.25h3.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
                          fill="white"
                        />
                        <path
                          d="m.75 7c-.414 0-.75-.336-.75-.75v-3.5c0-1.517 1.233-2.75 2.75-2.75h3.5c.414 0 .75.336.75.75s-.336.75-.75.75h-3.5c-.689 0-1.25.561-1.25 1.25v3.5c0 .414-.336.75-.75.75z"
                          fill="white"
                        />
                        <path
                          d="m17.25 19h-10.5c-.965 0-1.75-.785-1.75-1.75v-2.5c0-.414.336-.75.75-.75s.75.336.75.75v2.5c0 .138.112.25.25.25h10.5c.138 0 .25-.112.25-.25v-2.5c0-.414.336-.75.75-.75s.75.336.75.75v2.5c0 .965-.785 1.75-1.75 1.75z"
                          fill="white"
                        />
                        <path
                          d="m18.25 11c-.414 0-.75-.336-.75-.75v-3.5c0-.138-.112-.25-.25-.25h-10.5c-.138 0-.25.112-.25.25v3.5c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-3.5c0-.965.785-1.75 1.75-1.75h10.5c.965 0 1.75.785 1.75 1.75v3.5c0 .414-.336.75-.75.75z"
                          fill="white"
                        />
                        <path
                          d="m20.25 15.5h-16.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h16.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    Vulnerability Scanning
                  </NavLink>
                </li>
                <li>
                  <NavLink to={"/dashboard/more"} activeClassName="active-nav">
                    <div className="nav-icon">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M20.1818 3H3.81818C2.81403 3 2 3.89543 2 5V7C2 8.10457 2.81403 9 3.81818 9H20.1818C21.186 9 22 8.10457 22 7V5C22 3.89543 21.186 3 20.1818 3ZM3.81818 11H20.1818C21.186 11 22 11.8954 22 13V15C22 16.1046 21.186 17 20.1818 17H3.81818C2.81403 17 2 16.1046 2 15V13C2 11.8954 2.81403 11 3.81818 11ZM4 13V15H20V13H4ZM4 5V7H20V5H4ZM14 19H2V21H14V19Z"
                          fill="#E5E5E5"
                        />
                      </svg>
                    </div>
                    More
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={"/dashboard/notification"}
                    activeClassName="active-nav"
                  >
                    <div className="nav-icon">
                      <svg
                        width="16"
                        height="18"
                        viewBox="0 0 16 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.11387 14.5823L9.11387 15.4937C9.11387 16.1229 8.60381 16.6329 7.97463 16.6329C7.34544 16.6329 6.83539 16.1229 6.83539 15.4937L6.83539 14.5823H5.4683V15.4937C5.4683 16.8779 6.59042 18 7.97463 18C9.35884 18 10.481 16.8779 10.481 15.4937V14.5823H9.11387Z"
                          fill="white"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M13.625 5.15991C13.3593 2.23757 10.9091 0 7.97468 0C5.0403 0 2.59008 2.23757 2.32442 5.15991L1.91752 9.63575C1.8818 10.0287 1.64533 10.3751 1.29244 10.5516L1.28925 10.5532C0.499111 10.9482 0 11.7558 0 12.6392L0 12.9873C0 14.1199 0.9181 15.038 2.05063 15.038L13.8987 15.038C15.0313 15.038 15.9494 14.1199 15.9494 12.9873V12.6392C15.9494 11.7558 15.4503 10.9482 14.6601 10.5532L14.6569 10.5516C14.304 10.3751 14.0676 10.0287 14.0318 9.63575L13.625 5.15991ZM3.68589 5.28368C3.88754 3.0655 5.74736 1.36709 7.97468 1.36709C10.202 1.36709 12.0618 3.0655 12.2635 5.28368L12.6704 9.75952C12.749 10.6239 13.2692 11.3862 14.0487 11.7759C14.3757 11.9394 14.5823 12.2736 14.5823 12.6392V12.9873C14.5823 13.3649 14.2762 13.6709 13.8987 13.6709L2.05063 13.6709C1.67312 13.6709 1.36709 13.3649 1.36709 12.9873V12.6392C1.36709 12.2736 1.57364 11.9394 1.90382 11.7743C2.68017 11.3862 3.20041 10.6239 3.279 9.75952L3.68589 5.28368Z"
                          fill="#E5E5E5"
                        />
                      </svg>
                    </div>
                    Notifications
                  </NavLink>
                </li>
                <li onClick={this.handleOpen}>
                  <a href="#">
                    <div className="nav-icon">
                      <svg
                        width="25"
                        height="19"
                        viewBox="0 0 25 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.9869 7.19576C13.6898 6.7086 13.218 6.35319 12.6677 6.20206C12.1175 6.05094 11.5303 6.1155 11.0261 6.38256C10.5218 6.64962 10.1385 7.09905 9.95435 7.63912C9.77018 8.17919 9.79907 8.76919 10.0351 9.28869C10.2712 9.80819 10.6966 10.218 11.2245 10.4345C11.7524 10.6511 12.3431 10.658 12.8759 10.4538C13.4088 10.2497 13.8436 9.84984 14.0917 9.33599C14.3398 8.82214 14.3824 8.23299 14.2109 7.68877C14.1564 7.51599 14.0812 7.35044 13.9869 7.19576Z"
                          fill="white"
                        />
                        <path
                          d="M12.632 12.0818H11.487C10.523 12.0818 9.59841 12.4648 8.91672 13.1465C8.23502 13.8281 7.85205 14.7527 7.85205 15.7168V18.2278H16.2661V15.7168C16.2661 14.7527 15.8831 13.8281 15.2014 13.1465C14.5197 12.4648 13.5951 12.0818 12.631 12.0818H12.632Z"
                          fill="white"
                        />
                        <path
                          d="M7.70441 7.93932C9.4508 7.21544 10.2797 5.21289 9.55584 3.4665C8.83196 1.72011 6.82941 0.891204 5.08302 1.61508C3.33663 2.33896 2.50772 4.34151 3.2316 6.0879C3.95548 7.83429 5.95802 8.6632 7.70441 7.93932Z"
                          fill="white"
                        />
                        <path
                          d="M6.435 15.7159C6.43544 14.7164 6.73192 13.7395 7.28701 12.9083C7.84211 12.0772 8.63095 11.4291 9.554 11.0459C8.94454 10.4771 8.54704 9.71775 8.427 8.89285C7.86835 9.39535 7.1403 9.66791 6.389 9.65584C5.34 9.65708 4.31928 9.31579 3.482 8.68384C2.44913 9.1248 1.56851 9.85942 0.949495 10.7965C0.330475 11.7335 0.000313027 12.8318 0 13.9548L0 16.7448H6.435V15.7159Z"
                          fill="white"
                        />
                        <path
                          d="M20.1294 7.26125C21.4662 5.92448 21.4662 3.75716 20.1294 2.42039C18.7927 1.08363 16.6254 1.08363 15.2886 2.42039C13.9518 3.75716 13.9518 5.92448 15.2886 7.26125C16.6254 8.59801 18.7927 8.59801 20.1294 7.26125Z"
                          fill="white"
                        />
                        <path
                          d="M23.1989 10.8678C22.5797 9.89636 21.681 9.135 20.6209 8.68384C19.7838 9.31621 18.763 9.65787 17.7139 9.65685C17.3414 9.66096 16.9717 9.59163 16.6259 9.45282C16.2802 9.31401 15.9652 9.10843 15.6989 8.84784C15.5876 9.69033 15.1872 10.468 14.5659 11.0479C15.489 11.4311 16.2778 12.0792 16.8329 12.9103C17.388 13.7415 17.6845 14.7184 17.6849 15.7178V16.7468H24.1019V13.9568C24.1029 12.862 23.7895 11.7898 23.1989 10.8678Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    Invite
                  </a>
                </li>
                <li>
                  <NavLink
                    to={"/dashboard/feedback"}
                    activeClassName="active-nav"
                  >
                    <div className="nav-icon">
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M21.422 3.7505H20.722V2.1095C20.722 1.55003 20.4998 1.01347 20.1042 0.617858C19.7086 0.22225 19.172 0 18.6125 0C18.053 0 17.5165 0.22225 17.1209 0.617858C16.7253 1.01347 16.503 1.55003 16.503 2.1095V2.6855C16.5017 3.04165 16.3851 3.38779 16.1705 3.67208C15.956 3.95638 15.6551 4.16352 15.313 4.2625L14.628 4.4625V4.4535C14.628 4.26785 14.5543 4.0898 14.423 3.95853C14.2917 3.82725 14.1137 3.7535 13.928 3.7535H11.109C10.9234 3.7535 10.7453 3.82725 10.614 3.95853C10.4828 4.0898 10.409 4.26785 10.409 4.4535V7.5945H2.10902C1.55044 7.59529 1.01493 7.81733 0.619669 8.21203C0.224412 8.60672 0.00160992 9.14192 2.36104e-05 9.7005V23.3005C-0.00102483 23.4282 0.0328625 23.5537 0.0980183 23.6635C0.163174 23.7733 0.257117 23.8632 0.36968 23.9234C0.482243 23.9837 0.60914 24.012 0.736637 24.0053C0.864133 23.9986 0.987375 23.9572 1.09302 23.8855L3.72802 22.1285H17.109C17.6681 22.1277 18.2041 21.9053 18.5994 21.5099C18.9948 21.1146 19.2172 20.5786 19.218 20.0195V12.6565H21.418C22.1022 12.6568 22.7585 12.3854 23.2427 11.902C23.7268 11.4185 23.9992 10.7627 24 10.0785V6.3285C23.9992 5.64502 23.7274 4.98975 23.2441 4.50646C22.7608 4.02316 22.1055 3.75129 21.422 3.7505ZM11.812 5.1565H13.218V11.2505H11.812V5.1565ZM17.812 20.0155C17.812 20.2012 17.7383 20.3792 17.607 20.5105C17.4757 20.6418 17.2977 20.7155 17.112 20.7155H3.51602C3.3772 20.7153 3.24145 20.7564 3.12602 20.8335L1.40602 21.9835V9.7005C1.40602 9.51485 1.47977 9.3368 1.61105 9.20553C1.74232 9.07425 1.92037 9.0005 2.10602 9.0005H10.406V11.9535C10.406 12.1392 10.4798 12.3172 10.611 12.4485C10.7423 12.5798 10.9204 12.6535 11.106 12.6535H13.918C14.0911 12.6545 14.2584 12.5915 14.3876 12.4764C14.5169 12.3614 14.599 12.2025 14.618 12.0305C15.2538 12.4368 15.9925 12.6529 16.747 12.6535H17.811L17.812 20.0155ZM22.593 10.0785C22.5928 10.3893 22.4692 10.6872 22.2495 10.9069C22.0297 11.1267 21.7318 11.2502 21.421 11.2505H16.749C16.3289 11.2499 15.9153 11.1459 15.5449 10.9476C15.1744 10.7493 14.8585 10.4628 14.625 10.1135V5.9215L15.7 5.6155C16.3357 5.43171 16.8946 5.04683 17.293 4.51858C17.6915 3.99033 17.908 3.34716 17.91 2.6855V2.1095C17.91 1.92305 17.9841 1.74424 18.1159 1.6124C18.2478 1.48057 18.4266 1.4065 18.613 1.4065C18.7995 1.4065 18.9783 1.48057 19.1101 1.6124C19.242 1.74424 19.316 1.92305 19.316 2.1095V4.4535C19.316 4.63915 19.3898 4.8172 19.521 4.94847C19.6523 5.07975 19.8304 5.1535 20.016 5.1535H21.422C21.7328 5.15376 22.0307 5.27733 22.2505 5.49706C22.4702 5.7168 22.5938 6.01475 22.594 6.3255L22.593 10.0785Z"
                          fill="white"
                        />
                        <path
                          d="M3.50908 13.2135H8.19109C8.37674 13.2135 8.55478 13.1397 8.68606 13.0085C8.81733 12.8772 8.89108 12.6991 8.89108 12.5135C8.89108 12.3278 8.81733 12.1498 8.68606 12.0185C8.55478 11.8872 8.37674 11.8135 8.19109 11.8135H3.50908C3.32343 11.8135 3.14538 11.8872 3.01411 12.0185C2.88283 12.1498 2.80908 12.3278 2.80908 12.5135C2.80908 12.6991 2.88283 12.8772 3.01411 13.0085C3.14538 13.1397 3.32343 13.2135 3.50908 13.2135Z"
                          fill="white"
                        />
                        <path
                          d="M15.6831 14.6265H3.50908C3.41716 14.6265 3.32613 14.6446 3.2412 14.6797C3.15628 14.7149 3.07911 14.7665 3.01411 14.8315C2.94911 14.8965 2.89754 14.9737 2.86237 15.0586C2.82719 15.1435 2.80908 15.2346 2.80908 15.3265C2.80908 15.4184 2.82719 15.5094 2.86237 15.5943C2.89754 15.6793 2.94911 15.7564 3.01411 15.8214C3.07911 15.8864 3.15628 15.938 3.2412 15.9732C3.32613 16.0084 3.41716 16.0265 3.50908 16.0265H15.6831C15.775 16.0265 15.866 16.0084 15.951 15.9732C16.0359 15.938 16.1131 15.8864 16.1781 15.8214C16.2431 15.7564 16.2946 15.6793 16.3298 15.5943C16.365 15.5094 16.3831 15.4184 16.3831 15.3265C16.3831 15.2346 16.365 15.1435 16.3298 15.0586C16.2946 14.9737 16.2431 14.8965 16.1781 14.8315C16.1131 14.7665 16.0359 14.7149 15.951 14.6797C15.866 14.6446 15.775 14.6265 15.6831 14.6265Z"
                          fill="white"
                        />
                        <path
                          d="M15.6831 17.4395H3.50908C3.32343 17.4395 3.14538 17.5132 3.01411 17.6445C2.88283 17.7757 2.80908 17.9538 2.80908 18.1395C2.80908 18.3251 2.88283 18.5032 3.01411 18.6344C3.14538 18.7657 3.32343 18.8394 3.50908 18.8394H15.6831C15.8687 18.8394 16.0468 18.7657 16.1781 18.6344C16.3093 18.5032 16.3831 18.3251 16.3831 18.1395C16.3831 17.9538 16.3093 17.7757 16.1781 17.6445C16.0468 17.5132 15.8687 17.4395 15.6831 17.4395Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    Feedback
                  </NavLink>
                </li>
                <li>
                  <NavLink to={"/dashboard/help"} activeClassName="active-nav">
                    <div className="nav-icon">
                      <svg
                        width="23"
                        height="22"
                        viewBox="0 0 23 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M22.0042 14.8884C22.0017 13.3344 21.4915 11.8238 20.5512 10.5865C19.611 9.34929 18.2922 8.45317 16.7956 8.03461C16.7398 6.75929 16.3942 5.51345 15.7849 4.3917C15.1756 3.26995 14.3187 2.30178 13.2793 1.56072C12.2399 0.819653 11.0453 0.325177 9.7862 0.114839C8.52711 -0.0954983 7.23665 -0.0161666 6.01281 0.34681C4.78896 0.709787 3.66392 1.34686 2.72311 2.20966C1.7823 3.07246 1.05046 4.1383 0.583168 5.32623C0.115876 6.51416 -0.0745824 7.79296 0.0262559 9.06551C0.127094 10.3381 0.516578 11.5709 1.16513 12.6704L0.0313835 16.77L4.13193 15.6363C5.31889 16.3377 6.66071 16.735 8.03818 16.793C8.33112 17.8443 8.86201 18.8142 9.58977 19.6276C10.3175 20.4409 11.2227 21.076 12.2351 21.4835C13.2476 21.8911 14.3403 22.0603 15.4286 21.978C16.5169 21.8957 17.5717 21.5642 18.5114 21.009L21.974 21.9668L21.0153 18.5114C21.6648 17.4147 22.0064 16.163 22.0042 14.8884ZM4.33449 14.2423L1.88002 14.9214L2.55917 12.4624L2.40428 12.2204C1.46226 10.7431 1.09882 8.97012 1.38365 7.24139C1.66849 5.51265 2.58155 3.94995 3.9477 2.85301C5.31385 1.75607 7.03689 1.20213 8.78634 1.29746C10.5358 1.39278 12.1884 2.13064 13.4273 3.36952C14.6662 4.6084 15.4041 6.26106 15.4994 8.0105C15.5947 9.75995 15.0408 11.483 13.9438 12.8491C12.8469 14.2153 11.2842 15.1284 9.55546 15.4132C7.82672 15.698 6.05369 15.3346 4.57645 14.3926L4.33449 14.2423ZM20.1235 20.1218L18.3024 19.6177L18.0595 19.7763C17.3143 20.259 16.4687 20.5651 15.5872 20.671C14.7056 20.777 13.8116 20.68 12.9732 20.3876C12.1349 20.0952 11.3745 19.615 10.7502 18.9837C10.1258 18.3524 9.65401 17.5868 9.37081 16.7453C11.2509 16.5243 13.0016 15.676 14.3401 14.3375C15.6787 12.9989 16.5269 11.2482 16.7479 9.36816C17.5894 9.65145 18.3549 10.1233 18.9861 10.7477C19.6172 11.3721 20.0973 12.1325 20.3897 12.9708C20.682 13.8092 20.7789 14.7032 20.6729 15.5847C20.5669 16.4662 20.2608 17.3118 19.778 18.0568L19.6194 18.2997L20.1235 20.1218Z"
                          fill="white"
                        />
                        <path
                          d="M7.75732 11.6438H9.04688V12.9334H7.75732V11.6438Z"
                          fill="white"
                        />
                        <path
                          d="M9.69129 6.44357C9.69204 6.62273 9.65505 6.80003 9.58272 6.96395C9.5104 7.12786 9.40436 7.27471 9.27151 7.39492L7.75741 8.78071V10.3544H9.04697V9.34621L10.1468 8.34353C10.4631 8.05406 10.7023 7.69026 10.8426 7.28507C10.9829 6.87988 11.0199 6.44609 10.9503 6.02299C10.8807 5.59988 10.7067 5.20082 10.444 4.86192C10.1813 4.52303 9.83819 4.255 9.44579 4.08212C9.0534 3.90924 8.62407 3.83696 8.1967 3.87182C7.76933 3.90668 7.3574 4.04759 6.9982 4.28178C6.63901 4.51597 6.34391 4.83605 6.1396 5.21304C5.93529 5.59003 5.82824 6.01202 5.82812 6.44081H7.11768C7.12664 6.10487 7.26637 5.7857 7.50715 5.55126C7.74793 5.31682 8.07071 5.18563 8.40677 5.18563C8.74283 5.18563 9.06562 5.31682 9.30639 5.55126C9.54717 5.7857 9.68692 6.10487 9.69588 6.44081L9.69129 6.44357Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    Help
                  </NavLink>
                </li>
                {/* ------------------------------------------------------------------------------------- Admin Panel */}
                {this.state?.device_details?.user_type == "corporate" &&
                (this.state?.role_id == 3 || this.state?.role_id == 1) ? (
                  <li>
                    <NavLink
                      to={"/dashboard/admin"}
                      activeClassName="active-nav"
                    >
                      <div className="nav-icon">
                        <svg
                          width="25"
                          height="25"
                          viewBox="0 0 25 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.33333 9.99998C10.1743 9.99998 11.6667 8.5076 11.6667 6.66665C11.6667 4.8257 10.1743 3.33331 8.33333 3.33331C6.49238 3.33331 5 4.8257 5 6.66665C5 8.5076 6.49238 9.99998 8.33333 9.99998Z"
                            fill="white"
                          />
                          <path
                            d="M8.89169 10.85C8.70835 10.8417 8.52502 10.8334 8.33335 10.8334C6.31669 10.8334 4.43335 11.3917 2.82502 12.35C2.09169 12.7834 1.66669 13.6 1.66669 14.4584V16.6667H9.38335C8.79476 15.827 8.43918 14.8464 8.35281 13.8247C8.26645 12.8029 8.45238 11.7765 8.89169 10.85ZM17.2917 13.3334C17.2917 13.15 17.2667 12.9834 17.2417 12.8084L18.1917 11.9667L17.3584 10.525L16.15 10.9334C15.8834 10.7084 15.5834 10.5334 15.25 10.4084L15 9.16669H13.3334L13.0834 10.4084C12.75 10.5334 12.45 10.7084 12.1834 10.9334L10.975 10.525L10.1417 11.9667L11.0917 12.8084C11.0667 12.9834 11.0417 13.15 11.0417 13.3334C11.0417 13.5167 11.0667 13.6834 11.0917 13.8584L10.1417 14.7L10.975 16.1417L12.1834 15.7334C12.45 15.9584 12.75 16.1334 13.0834 16.2584L13.3334 17.5H15L15.25 16.2584C15.5834 16.1334 15.8834 15.9584 16.15 15.7334L17.3584 16.1417L18.1917 14.7L17.2417 13.8584C17.2667 13.6834 17.2917 13.5167 17.2917 13.3334ZM14.1667 15C13.25 15 12.5 14.25 12.5 13.3334C12.5 12.4167 13.25 11.6667 14.1667 11.6667C15.0834 11.6667 15.8334 12.4167 15.8334 13.3334C15.8334 14.25 15.0834 15 14.1667 15Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      Admin Panel
                    </NavLink>
                  </li>
                ) : null}
                <li onClick={this.handleLogout}>
                  <a href="#">
                    <div className="nav-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 400 300"
                      >
                        <g
                          id="icon"
                          transform="translate(-1.9443888888888807 -1.9443888888888807) scale(3.89 3.89)"
                        >
                          <path
                            d="M 86.356 46.27 c 0.031 -0.065 0.059 -0.131 0.085 -0.199 c 0.042 -0.11 0.076 -0.222 0.104 -0.336 c 0.016 -0.062 0.034 -0.123 0.046 -0.186 c 0.034 -0.181 0.055 -0.364 0.055 -0.548 l 0 0 c 0 0 0 0 0 0 c 0 -0.184 -0.022 -0.367 -0.055 -0.548 c -0.012 -0.064 -0.03 -0.124 -0.046 -0.186 c -0.029 -0.114 -0.062 -0.226 -0.104 -0.336 c -0.026 -0.068 -0.055 -0.134 -0.086 -0.199 c -0.046 -0.099 -0.099 -0.194 -0.156 -0.288 c -0.039 -0.063 -0.077 -0.126 -0.12 -0.186 c -0.02 -0.027 -0.033 -0.057 -0.054 -0.084 L 74.316 27.93 c -1.009 -1.313 -2.894 -1.561 -4.207 -0.551 c -1.313 1.009 -1.561 2.893 -0.551 4.207 L 77.56 42 H 30.903 c -1.657 0 -3 1.343 -3 3 c 0 1.657 1.343 3 3 3 h 46.656 l -8.001 10.414 c -1.01 1.314 -0.763 3.197 0.551 4.207 c 0.545 0.419 1.188 0.621 1.826 0.621 c 0.9 0 1.79 -0.403 2.381 -1.172 l 11.71 -15.242 c 0.021 -0.027 0.035 -0.057 0.055 -0.085 c 0.043 -0.06 0.08 -0.122 0.119 -0.184 C 86.257 46.464 86.31 46.369 86.356 46.27 z"
                            transform=" matrix(1 0 0 1 0 0) "
                            strokeLinecap="round"
                            fill="white"
                          />
                          <path
                            d="M 60.442 90 H 9.353 c -1.657 0 -3 -1.343 -3 -3 V 3 c 0 -1.657 1.343 -3 3 -3 h 51.089 c 1.657 0 3 1.343 3 3 v 30.054 c 0 1.657 -1.343 3 -3 3 s -3 -1.343 -3 -3 V 6 H 12.353 v 78 h 45.089 V 55.61 c 0 -1.657 1.343 -3 3 -3 s 3 1.343 3 3 V 87 C 63.442 88.657 62.1 90 60.442 90 z"
                            transform=" matrix(1 0 0 1 0 0) "
                            strokeLinecap="round"
                            fill="white"
                          />
                        </g>
                      </svg>
                    </div>
                    Logout
                  </a>
                </li>
              </ul>
            </nav>
          </div>
          <div className="mx-auto text-center mt-3">
            <img
              src={logo}
              alt="cervais"
              title="cervais"
              style={{ height: "50px", marginTop: 50 }}
            />
          </div>
        </aside>

        {this.state.showModal ? (
          <Modal
            open={this.state.showModal}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div
              className="modal-dialog modal-dialog-centered modal_dialog_forgot_pw"
              role="document"
            >
              <div className="modal-content modal_fp_content">
                <div className="modal-header forget_pw_header">
                  <button
                    type="button"
                    className="close modal_fp_close_btn"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={this.handleClose}
                  >
                    <span aria-hidden="true">
                      <svg
                        width="10"
                        height="18"
                        viewBox="0 0 10 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M2.91937 9.00008L9.82886 1.70718L8.48899 0.292969L0.23964 9.00008L8.48899 17.7072L9.82886 16.293L2.91937 9.00008Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                  </button>
                  <h5
                    className="modal-title modal_fp_title "
                    id="exampleModalLabel"
                  >
                    Invite
                  </h5>
                </div>

                <div className="modal-body fp_modal_body">
                  <div className="col-12 col-sm-12 col-md-12 modal_fp_body">
                    <div className="fp_label">
                      <h6>
                        Email ID<em className="mandatory">* </em>
                      </h6>
                      <input
                        type="email"
                        className="fp_modal_input"
                        value={this.state.email}
                        onChange={this.handleEmail}
                      />
                    </div>
                    <div className="color-red">
                      <i>{this.state.errorEmail}</i>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 modal_fp_body">
                    <div className="fp_label">
                      <h6>
                        Select a Role<em className="mandatory">* </em>
                      </h6>
                      <select
                        id="invite"
                        className="fp_modal_input"
                        onChange={this.changeUsertype}
                        value={this.state.userType}
                      >
                        <option value="Admin" defaultValue>
                          Admin
                        </option>
                        <option value="Guest">Guest</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="modal-footer footer_fp_modal">
                  <button
                    type="button"
                    className="btn-fp-footer btn-Reset"
                    onClick={this.postInviteUser}
                    disabled={this.state.loader}
                  >
                    Invite
                    {this.state.loader ? (
                      <i className="fa fa-spinner fa-spin"></i>
                    ) : null}
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        ) : null}

        {this.state.showLogout ? (
          <Modal
            open={this.state.showLogout}
            aria-labelledby="logoutModal"
            aria-hidden="true"
          >
            <div
              className="modal-dialog modal-dialog-centered modal_dialog_forgot_pw"
              role="document"
            >
              <div className="modal-content modal_fp_content">
                <div className="modal-header forget_pw_header">
                  <button
                    type="button"
                    className="close modal_fp_close_btn"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={this.handleClose}
                  >
                    <span aria-hidden="true">
                      <svg
                        width="10"
                        height="18"
                        viewBox="0 0 10 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M2.91937 9.00008L9.82886 1.70718L8.48899 0.292969L0.23964 9.00008L8.48899 17.7072L9.82886 16.293L2.91937 9.00008Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                  </button>
                  <h5
                    className="modal-title modal_fp_title "
                    id="exampleModalLabel"
                  >
                    Logout?
                  </h5>
                </div>

                <div className="modal-body fp_modal_body">
                  <div className="col-12 col-sm-12 col-md-12 modal_fp_body mr-t20 mr-b20 text-center">
                    <h6 style={{ color: "white" }}>
                      Are you sure you want to logout?
                    </h6>
                  </div>
                </div>

                <div className="modal-footer footer_fp_modal">
                  <button
                    type="button"
                    className="btn-fp-footer btn-Reset"
                    onClick={this.logoutUser}
                    disabled={this.state.loader}
                  >
                    Logout
                    {this.state.loader ? (
                      <i className="fa fa-spinner fa-spin"></i>
                    ) : null}
                  </button>
                  <button
                    type="button"
                    className="btn-fp-footer btn-Reset"
                    onClick={this.handleClose}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        ) : null}

        {this.state.isAuthenticated ? (
          <Switch>
            <Route
              path="/dashboard/home"
              component={Home}
              isAuthenticated={this.state.isAuthenticated}
            />
            <Route
              path="/dashboard/access"
              component={Access}
              isAuthenticated={this.state.isAuthenticated}
            />
            <Route
              path="/dashboard/trusted"
              component={Trusted}
              isAuthenticated={this.state.isAuthenticated}
            />
            <Route
              path="/dashboard/chat/:id/:name"
              component={Chat}
              isAuthenticated={this.state.isAuthenticated}
            />
            <Route
              path="/dashboard/dataSharing"
              component={DataSharing}
              isAuthenticated={this.state.isAuthenticated}
            />
            <Route
              path="/dashboard/fileSharing"
              component={FileSharing}
              isAuthenticated={this.state.isAuthenticated}
            />
            <Route
              path="/dashboard/mqttFileSharing"
              component={MqttFileSharing}
              isAuthenticated={this.state.isAuthenticated}
            />
            <Route
              path="/dashboard/mqttSubFileSharing"
              component={MqttSubFileSharing}
              isAuthenticated={this.state.isAuthenticated}
            />
            <Route
              path="/dashboard/upgradePlan"
              component={UpgradePlan}
              isAuthenticated={this.state.isAuthenticated}
            />
            <Route
              path="/dashboard/subFileSharing"
              component={SubFileSharing}
              isAuthenticated={this.state.isAuthenticated}
            />
            <Route
              path="/dashboard/map"
              component={Maps}
              isAuthenticated={this.state.isAuthenticated}
            />
            <Route
              path="/dashboard/details"
              component={IOTDevicesDetails}
              isAuthenticated={this.state.isAuthenticated}
            />
            <Route
              path="/dashboard/iotdetails"
              component={IotDevices}
              isAuthenticated={this.state.isAuthenticated}
            />
            <Route
              path="/dashboard/settings"
              component={Settings}
              isAuthenticated={this.state.isAuthenticated}
            />
            <Route
              path="/dashboard/profile"
              component={Profile}
              isAuthenticated={this.state.isAuthenticated}
            />
            <Route
              path="/dashboard/registration"
              component={Registration}
              isAuthenticated={this.state.isAuthenticated}
            />
            <Route
              path="/dashboard/connectedUsers"
              component={ConnectedUsers}
              isAuthenticated={this.state.isAuthenticated}
            />
            <Route
              path="/dashboard/connectedDevices"
              component={ConnectedDevices}
              isAuthenticated={this.state.isAuthenticated}
            />
            <Route
              path="/dashboard/switchDevices"
              component={SwitchDevice}
              isAuthenticated={this.state.isAuthenticated}
            />
            <Route
              path="/dashboard/vulnerabilityScan"
              component={VulnerabilityScan}
              isAuthenticated={this.state.isAuthenticated}
            />
            <Route
              path="/dashboard/UpdateVulnerabilityScan/:id"
              component={UpdateVulnerabilityScan}
              isAuthenticated={this.state.isAuthenticated}
            />
            <Route
              path="/dashboard/reports/:id"
              component={VulnerabilityScanReportsById}
              isAuthenticated={this.state.isAuthenticated}
            />
            <Route
              path="/dashboard/more"
              component={More}
              isAuthenticated={this.state.isAuthenticated}
            />
            <Route
              path="/dashboard/aboutUs"
              component={AboutUs}
              isAuthenticated={this.state.isAuthenticated}
            />
            <Route
              path="/dashboard/notification"
              component={Notification}
              isAuthenticated={this.state.isAuthenticated}
            />

            <Route
              path="/dashboard/feedback"
              component={Feedback}
              isAuthenticated={this.state.isAuthenticated}
            />
            <Route
              path="/dashboard/help"
              component={Help}
              isAuthenticated={this.state.isAuthenticated}
            />
            <Route
              path="/dashboard/admin"
              component={Admin}
              isAuthenticated={this.state.isAuthenticated}
            />
          </Switch>
        ) : (
          <Route path="/dashboard/404" component={Error404} />
        )}
      </main>
    );
  }
}

export default dashboard;
